const buyOneClickTools = {
    openModalWindow: function (modal) {
        closeAllModal();
        $('body').append(modal);        
    },

    buyOneClickSort: function (element) {
        const variant = element.attr('data-is-variants');

        const dataObj = {
            lang: lang,
            type: 'buy_one_click',
            id: element.attr('data-id'),
            good_id: element.attr('data-id'),
            quantity: 1,
            gtm: toolsGtm.gtmAddToCartSort(element, 'full'),
        };

        if (variant == 1) {
            this.getVariants(dataObj);
        } else {
            handleModalAction('buy_one_click', dataObj);
        }
    },

    getVariants: function (dataObj) {
        $.post(requests.getVariants, dataObj, function (data) {
            if (data.status == 'success') {
                buyOneClickTools.openModalWindow(data.html);
            }
        });
    },
};

$(document).ready(function () {
    $(document).on('click', '.js_buy__one-click', function () {
        const btn = $(this);
        buyOneClickTools.buyOneClickSort(btn);
    });
});